import { drivers } from '../config';
export = drivers.tedious;
